import { call, put, takeLatest } from 'redux-saga/effects';
import { get, includes } from 'lodash';
import {
  actionTypes,
  fetchCalendarEventsSuccess,
  fetchCalendarEventsFailure,
  fetchCalendarYearsSuccess,
  fetchCalendarYearsFailure,
  fetchCalendarEventsByYear,
} from './actions';
import getCalendarEvents from '../../services/API/getCalendarEvents';
import getCalendarYears from '../../services/API/getCalendarYears';

function* fetchCalendarYearsSaga() {
  const response = yield call(getCalendarYears);
  const data = get(response, 'data');
  if (response.isOk) {
    yield put(fetchCalendarYearsSuccess(data));
    const currentYear = new Date().getFullYear();
    if (includes(data, currentYear)) {
      return yield put(fetchCalendarEventsByYear(currentYear));
    }
    return yield put(fetchCalendarEventsSuccess([]));
  }
  return yield put(fetchCalendarYearsFailure(get(response, 'error')));
}

function* fetchCalendarEventsByYearSaga({ payload }) {
  const response = yield call(getCalendarEvents, payload);
  if (response.isOk) {
    return yield put(fetchCalendarEventsSuccess(get(response, 'data')));
  }
  return yield put(fetchCalendarEventsFailure(get(response, 'error')));
}

export default function* calendarEventsSaga() {
  yield takeLatest(actionTypes.YEARS_LIST_START, fetchCalendarYearsSaga);
  yield takeLatest(actionTypes.EVENTS_BY_YEAR_START, fetchCalendarEventsByYearSaga);
}
